'use strict';

import Ssim from './ssim';
import EventEmitter from '../helpers/EventEmmiter';

export default class VideoFrameChecker extends EventEmitter {
    constructor(videoElement) {
        super();

        this.frameStats = {
            numFrozenFrames: 0,
            numBlackFrames: 0,
            numFrames: 0
        };

        this.reloadStates_ = 0;

        this.running_ = true;

        this.checkVideoFrameTimer_ = null;

        this.nonBlackPixelLumaThreshold = 20;
        this.previousFrame_ = [];
        this.identicalFrameSsimThreshold = 0.985;
        this.frameComparator = new Ssim();
        this.listenerForVideo = null;

        this.canvas_ = document.createElement('canvas');
        this.videoElement_ = videoElement;
        this.listener_ = this.checkVideoFrame_.bind(this);

        this.videoElement_.addEventListener('play', this.listener_, false);
        this.videoElement_.addEventListener('abort', this.e3BrokeStream.bind(this, 'abort'), false);
        this.videoElement_.addEventListener('ended', this.e3BrokeStream.bind(this, 'ended'), false);
        this.videoElement_.addEventListener('error', this.e3BrokeStream.bind(this, 'error'), false);
        this.videoElement_.addEventListener('interruptbegin', this.e3BrokeStream.bind(this, 'interruptbegin'), false);
        this.videoElement_.addEventListener('interruptend', this.e3BrokeStream.bind(this, 'interruptend'), false);
        this.videoElement_.addEventListener('waiting', this.e3BrokeStream.bind(this, 'waiting'), false);

        this._addlistenerForVideo();
    }

    _addlistenerForVideo(){
        this.listenerForVideo = setTimeout(() => {
            this.e3BrokeStream('video-is-not-playing', {msg: 'video-is-not-playing'});
        }, 15000)
    }

    _removelistenerForVideo(){
        if(this.listenerForVideo){
            clearTimeout(this.listenerForVideo);
            this.listenerForVideo = null;
        }
    }

    e3BrokeStream(type, error){
        this._fireEvent('e3-broken-stream');
        console.log(`VideoFrameChecker ${type}`, error)
    }

    stop() {
        this._removelistenerForVideo();
        this.videoElement_.removeEventListener('play' , this.listener_);
        this.running_ = false;
        clearTimeout(this.checkVideoFrameTimer_);
    }

    resume() {
        this.videoElement_.addEventListener('play' , this.listener_);
        this.running_ = true;
    }

    getCurrentImageData_() {
        this.canvas_.width = this.videoElement_.width || this.videoElement_.clientWidth;
        this.canvas_.height = this.videoElement_.height || this.videoElement_.clientHeight;

        var context = this.canvas_.getContext('2d');
        context.drawImage(this.videoElement_, 0, 0, this.canvas_.width,
            this.canvas_.height);
        var res;
        try {
            res = context.getImageData(0, 0, this.canvas_.width, this.canvas_.height);
        } catch(e) {
            res = false;
            console.error(e);
        }

        return res;
    }

    checkVideoFrame_() {
        if (!this.running_) {
            return;
        }
        if (this.videoElement_.ended) {
            return;
        }

        var imageData = this.getCurrentImageData_();

        if (!imageData) {
            this.checkVideoFrameTimer_ = setTimeout(this.checkVideoFrame_.bind(this), 1000);
            return;
        }

        if (this.isBlackFrame_(imageData.data, imageData.data.length)) {
            this.frameStats.numBlackFrames++;
        } else {
            this.frameStats.numBlackFrames = 0;
        }

        if (this.frameComparator.calculate(this.previousFrame_, imageData.data) >
            this.identicalFrameSsimThreshold) {
            this.frameStats.numFrozenFrames++;
        } else {
            this.frameStats.numFrozenFrames = 0;
        }

        if ((this.frameStats.numBlackFrames > 5 || this.frameStats.numFrozenFrames > 5) && !this.reloadStates_) {
            this.restartVideoStream_();
            // console.log('==== Restart stream ====');
        } else if ((this.frameStats.numBlackFrames > 5 || this.frameStats.numFrozenFrames > 5) && this.reloadStates_) {
            this.stop();
            this._fireEvent('e3-broken-stream');
            return;
        }

        this.previousFrame_ = imageData.data;

        this.frameStats.numFrames++;
        // setTimeout(this.checkVideoFrame_.bind(this), 20);

        if (this.frameStats.numFrames > 20) {
            this.stop();
        } else {
            this._removelistenerForVideo();
            this.checkVideoFrameTimer_ = setTimeout(this.checkVideoFrame_.bind(this), 1000);
        }
    }

    isBlackFrame_(data, length) {
        // TODO: Use a statistical, histogram-based detection.
        var thresh = this.nonBlackPixelLumaThreshold;
        var accuLuma = 0;
        for (var i = 4; i < length; i += 4) {
            // Use Luma as in Rec. 709: Y′709 = 0.21R + 0.72G + 0.07B;
            accuLuma += 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
            // Early termination if the average Luma so far is bright enough.
            if (accuLuma > (thresh * i / 4)) {
                return false;
            }
        }
        return true;
    }

    restartVideoStream_() {
        clearTimeout(this.checkVideoFrameTimer_);
        this.stop();
        var videoTrack = this.videoElement_.srcObject.getVideoTracks()[0];
        if(!videoTrack) return ;
        this.frameStats.numFrozenFrames = 0;
        this.frameStats.numBlackFrames = 0;
        videoTrack.enabled = false;
        setTimeout(function () {
            videoTrack.enabled = true;
            this.reloadStates_ += 1;
            this.resume();
        }.bind(this), 100);
    }
}
